import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useTableCheckboxStore = create<{ [tableId: string]: unknown[] }>()(
  persist((_) => ({}), {
    name: 'table-checkbox-storage'
  })
)

export const setCheckboxTableStore = <T>(tableId: string, data: T[]) => {
  useTableCheckboxStore.setState((prevState) => ({ ...prevState, [tableId]: data }))
}

export const resetCheckboxTableStore = (tableId: string) => {
  useTableCheckboxStore.setState((prevState) => ({ ...prevState, [tableId]: [] }))
}

export const resetAllCheckboxTableStores = () => {
  useTableCheckboxStore.setState({}, true)
}
